import { NerdStackFooter } from "../components/NerdStackFooter.jsx";
import BackArrow from "../components/BackArrow.jsx";
import { gradientFor } from "../components/toolGradients.js";
import { ToolPageBadge } from "../components/ToolPageBadge.jsx";

// NerdGames accent = rose (per locked icon-derived rule: in-app accent =
// icon gradient START hue). G badge gradient rose -> deepened rose.
export const GAMES_ACCENT = "#EC4899";

export function GamesShell({ title, children, back = "/games" }) {
  return (
    <div
      style={{
        minHeight: "100vh",
        background: "#0A0B14",
        color: "#E8E9F3",
        display: "flex",
        flexDirection: "column",
        paddingTop: "env(safe-area-inset-top)",
        paddingBottom: "env(safe-area-inset-bottom)",
      }}
    >
      <header
        style={{
          display: "flex",
          alignItems: "center",
          gap: 12,
          padding: "16px 18px",
          borderBottom: "1px solid #1C1E2E",
          position: "sticky",
          top: 0,
          background: "#0A0B14",
          zIndex: 10,
        }}
      >
        <BackArrow to={back} from={GAMES_ACCENT} toColor={gradientFor(title, "/games/x").from} />
        <ToolPageBadge name={title} family="games" accent={GAMES_ACCENT} />
        <h1 style={{ fontSize: 17, fontWeight: 600, margin: 0 }}>{title}</h1>
      </header>
      <main style={{ flex: 1, padding: "clamp(20px, 3vw, 36px) clamp(18px, 4vw, 40px)", maxWidth: "min(900px, 92vw)", width: "100%", margin: "0 auto" }}>
        {children}
      </main>
      <footer style={{ padding: "14px 18px", borderTop: "1px solid #1C1E2E" }}>
        <NerdStackFooter variant="tool" family="games" />
      </footer>
    </div>
  );
}
